
import { defineComponent, ref } from 'vue'
import CbtAccordion from '@/components/block/CbtAccordion.vue'

export default defineComponent({
  name: 'CbtAnswerCommentaryItem',
  components: {
    CbtAccordion
  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },

  setup(props) {
    const isCorrect = () => {
      const correctAnswer = props.data.answers.find(
        (key: any) => key.right_flag === true
      )
      return correctAnswer.answer_check === props.data.answer
    }
    const correctAnswerText = () => {
      const correctAnswer = props.data.answers.find(
        (key: any) => key.right_flag === true
      )
      return correctAnswer.answer
    }
    const accordionTexts = []
    if (props.data.commentary) {
      accordionTexts.push({
        head: '解答・解説',
        body: props.data.commentary
      })
    }
    if (props.data.commentary_point) {
      accordionTexts.push({
        head: '解法のポイント',
        body: props.data.commentary_point
      })
    }

    return {
      isCorrect,
      correctAnswerText,
      accordionTexts
    }
  }
})
